export var config = {
    loginMobile : '/api/v1/login/',
    getRole : '/pam/api/v1/notify/get-user-details?mobileNumber=',
    verifyOTP : '/api/v1/verify/',
    resendOTP : '/api/v1/resend/',
    registerMobile : '/api/v1/register/mobile',
    notification : '/api/v1/syncNotification/',
    getUserNotification: '/notifyCardCreation/getClientDetails',
    insuranceDetails : '/api/v1/syncData/insurances/',
    checkIn : '/api/v1/checkIN/',
    checkOut : '/api/v1/checkOUT/',
    leaveCount : '/api/v1/getLeavesLeft/',
    UpdatedleaveCount:'/api/v1/getLeavesLeftForUser/',
    InOutCount : '/api/v1/user/',
    teamCount : '/api/v1/getTeamMembersForSupervisor/',
    applyLeaves: '/api/v1/planLeavesForUser/',
    cancelLeaves : '/api/v1/cancelLeavesForUser/',
    getTeamList : '/api/v1/getTeamMembersDataForSupervisor/',
    UpdatedgetTeamList:'/api/v1/getTeamMembersForSupervisorwithLeavesLeft/',
    addInsurance : '/api/v1/syncData/insurances',
    addPolicies : '/api/v1/policies/add-user-policies/',
    uploadPolicyAttachment:'/api/v1/syncAttachment/',
    checkInSupervisor: '/api/v1/teamCheckInApprovalBySupervisor/',
    supervisorLeaveApprove: '/api/v1/teamLeaveApprovalBySupervisor/',
    getUserProfile:'/api/v1/getUserProfile/',
    getSetProfile: '/api/v1/profile',
    deleteNotification: '/api/v1/deleteNotification',
    viewNotification: '/api/v1/syncNotification',
    createProspect: '/profession/api/v1/createOrUpdateProspect',
    getProductUrl: '/api/v1/getProductURL',
    saveFHIProspect: '/profession/api/v1/createOrUpdateProspect',
    getPersonalAccident : '/api/v1/getReligareQuote',
    getManufacturerList : '/api/v1/getManufacturerCodes',
    getManufacturerListMS : '/individual-insurance/api/v1/motor-insurance/manufacturer-codes',
    getVehicleList : '/individual-insurance/api/v1/api/v1/getVehicleCode',
    getVehicleListMS : '/individual-insurance/api/v1/motor-insurance/vehicle-codes',
    getStateList : '/individual-insurance/api/v1/api/v1/getLocationCodes',
    getStateListMS : '/individual-insurance/api/v1/motor-insurance/location',
    getStateListALL:'/profession/api/v1/doctor-professional-indemnity/icici-lombard/state',
    getCityListALL:'/profession/api/v1/doctor-professional-indemnity/icici-lombard/city',
    getCityList: '/individual-insurance/api/v1/api/v1/populateCityCodes',
    getCityListMS: '/individual-insurance/api/v1/motor-insurance/populate-city-codes',
    getRtoAgency : '/individual-insurance/api/v1/motor-insurance/rto-master-go-digit',
    motorGoDigitVehicleCode : '/calc/hdfcToGodigitVehicleCodeCalc',
    motorComparePremium: '/individual-insurance/api/v1/motor-insurance/compare-premium',
    motorFetchQuoteDetails : '/individual-insurance/api/v1/motor-insurance/getQuotation',
    saveMotorQuoteDetails : '/individual-insurance/api/v1/motor-insurance/save-motor-details',
    saveMotorProposalHdfc : '/individual-insurance/api/v1/motor-insurance-hdfc/save-motor-proposal-details',
    saveMotorProposalGodigit : '/individual-insurance/api/v1/motor-insurance-go-digit/save-proposal-details',
    getMotorHdfcOtp: '/individual-insurance/api/v1/motor-insurance-hdfc/otp',
    motorCalculatePremiumHdfc: '/individual-insurance/api/v1/motor-insurance-hdfc/calculate-premium',
    motorCalculatePremiumGoDigit : '/individual-insurance/api/v1/motor-insurance-go-digit/calculate-premium',
    motorGethdfcProposal: '/individual-insurance/api/v1/motor-insurance-hdfc/generate-proposal-number',
    motorGoDigitGeneratePolicy: '/individual-insurance/api/v1/motor-insurance-go-digit/generate-policy-number',
    motorInitiatePayment:'/individual-insurance/api/v1/motor-insurance-go-digit/proceed-to-payment-gateway',
    motorGoDigitPaymentAck : '/individual-insurance/api/v1/motor-insurance-go-digit/payment-acknowledgement',
    motorGoDigitdownloadPDF : '/individual-insurance/api/v1/motor-insurance-go-digit/policy-pdf-url',
    motorFetchValidPlansHdfc : '/individual-insurance/api/v1/motor-insurance-hdfc/fetch-valid-plans',
    motorCalculateHdfc : '/individual-insurance/api/v1/motor-insurance-hdfc/calculate-idv',
    motorFetchValidPlansGodigit : '/individual-insurance/api/v1/motor-insurance-go-digit/fetch-valid-plans',
    motorCalculateGodigit : '/individual-insurance/api/v1/motor-insurance-go-digit/calculate-idv',
    getGodigitPincodeSortedA : '/individual-insurance/api/v1/motor-insurance-go-digit/location-codeA',
    getGodigitPincodeSortedB : '/individual-insurance/api/v1/motor-insurance-go-digit/location-codeB',
    getHdfcPincodeSorted:'/JSON/motorInsurance/PincodeHdfc.json',
    getProductId: '/api/v1/getProductID',
    goDigitInsurerCode : '/individual-insurance/api/v1/motor-insurance-go-digit/insurer-codes',
    getInsuropediaResult: '/api/v1/insuropediaSearch',
    getSumInsuredList: '/api/notify/personal-accident/v1/getSumInsuredList',
    getPAQuoteDetails:'/api/notify/personal-accident/v1/getQuotes',
    PAdownloadPDF:'/personalAccident/downloadPDF',
    PAsendPDFEmail:'/personalAccident/sendPDFEmail',
    getNomineeList: '/api/notify/personal-accident/v1/getNomineeList',
    getOccupationList: '/api/notify/personal-accident/v1/getOccupationList',
    getCityStateList: '/api/notify/personal-accident/v1/getStateAndCityList',
    getProposalService: '/api/notify/personal-accident/v1/getPremium',
    getTransactionURL: '/api/notify/personal-accident/v1/getTransactionURL',
    getTransactionResponsePA: '/api/v1/getTransactionDetails',
    addFamily: '/api/v1/updateFamily/',
    // for refer
    referFriendURL: '/api/v1/createProspectFromReferral',
    getCities: '/public/getLocation',
    sentEmail: '/api/v1/emailToSupport',
    //for Claim intimate/register
    getIntimateGroupPolicyData: '/api/v1/getpolicyforghi/insurances/null',
    getIntimateIndividualPolicyData : '/api/notify/v1/getIndividualPolicyDetail',
    //for Claim Submission
    submitClaimIntimate : '/api/notify/v1/saveClaimsDetails',
    getHospitals : '/pam/api/v1/eclaims/hospital-data',
    submitClaimIntimateMS : '/pam/api/v1/eclaims/save-claim',
    submitClaimIntimateMSUsingNotify: '/api/v1/policy/eclaims/save-claim',
    savedClaimData : '/pam/api/v1/eclaims/get-registered-claims/',
    savedClaimDataUsingNotify: '/api/v1/policy/eclaims/get-registered-claims/',
    claimInfo : '/pam/api/v1/eclaims/get-claim-info/',
    claimInfoUsingNotify: '/api/v1/policy/eclaims/get-claim-info/',
    sendMailOnClaim:'/pam/api/v1/eclaims/send-mail',
    sendMailOnClaimUsingNotify: '/api/v1/policy/eclaims/send-mail',
    uploadDoc : '/pam/api/v1/eclaims/upload-file',
    getDoc : '/pam/api/v1/eclaims/',
    getDocUsingNotify: '/api/v1/policy/eclaims/get/',
    deleteDoc : '/pam/api/v1/eclaims/delete-file/',
    //for Claim Status
    intimationNumberList: '/pam/api/v1/eclaims/get-intimation-number/',
    intimationNumberListUsingNotify: '/api/v1/policy/eclaims/get-intimation-number/',
    // launch offer
    submitLaunchOffer : '/api/v1/savelaunchoffer/',
    getLaunchOfferData : '/api/v1/getlaunchoffer/',
    getArticlesData : '/api/v1/getArticel/',
    sendLikeArticle : '/api/v1/savelikedetails/',
    getLikeCount : '/api/v1/getLikeCount/',
    saveReferral : '/api/v1/savereferall/',
    getDoctorPIquoteDetails : '/calc/doctorProfessionalIndemnityFutureAndUnitedIndiaCalc',
    saveIndemnityUnitedIndiaData : '/profession/api/v1/saveDoctorProfessionalIndemnityData',
    downloadDocPIPDF:'/profession/api/v1/DoctorProfessionalIndemnity/downloadDoctorPIPDF/',
    sendMailDocPIPDF: '/profession/api/v1/DoctorProfessionalIndemnity/sendDoctorPIPDFMail/',
    initiatePayment: '/profession/api/v1/transaction/initiatePayment',
    paymentStatus: 'profession/api/v1/payment-acknowledge-razorpay',
    saveSubmitDoctorProfessionalProposal : '/profession/api/v1/submitProposalForm',
    // Wellness Product
    updateWellnessRegistration : "/api/v1/wellnessproduct-leadgeneration",
    // for Covid
    // creatProspectForCovid : '/individual-insurance/api/v1/covid-protection/create-or-update-prospect',
    creatProspectForCovid : '/profession/api/v1/createOrUpdateProspect',
    creatProspectForDca : '/individual-insurance/api/v1/hospital-cash/save-prospect',
    creatProspectForHomeLoan : '/individual-insurance/api/v1/home-loan/save-prospect',
    creatProspectForMaxLife : '/individual-insurance/api/v1/max-life-insurance/save-prospect-auto-assign',
    createprospectforTopupHealth: '/individual-insurance/api/v1/topup-health-insurance/save-prospect',
    saveQuoteDataCovid : '/individual-insurance/api/v1/covid-protection/save-quote/prospect/',
    downloadCovidPDF : '/individual-insurance/api/v1/covid-protection/download-pdf/quote/',
    sendCovidPDF : '/individual-insurance/api/v1/covid-protection/email-pdf/quote/',
    saveProposalForCovid: '/individual-insurance/api/v1/covid-protection/save-proposal-form',
    initiatePaymentForCovid : '/individual-insurance/api/v1/transaction/initiate-payment',
    submitFamilyHealthAge: '/individual-insurance/api/v1/family-health-insurance/premium-quote-details',
    familyHealthQuote: '/calc/individualHealthNewCalc',
    careFamilyHealthQuote: '/calc/familyHealthInsuranceCareHealthCalc',
    healthCreateProspect: '/profession/api/v1/createOrUpdateProspect',
    saveHeathDetails: '/individual-insurance/api/v1/family-health-insurance/save-individual-health-details',
    getCityStateForRoyalSundaram: '/individual-insurance/api/v1/family-health-insurance/royal-sundaram-state-city-list',
    getFamilyHealthPremiumForRoayalSundram: '/individual-insurance/api/v1/family-health-insurance/default-premium-royal-sundaram',
    FamilyHealthSaveProspect: '/individual-insurance/api/v1/family-health-insurance/save-proposal-details',
    careFamilyHealthSaveProspect:'/individual-insurance/api/v1/family-health-insurance/save-care-health-proposal-details',
    familyHealthRoyalSundramPaymentGateway : '/individual-insurance/api/v1/api/v1/transaction/proceed-to-payment-gateway',
    familyHealthCalculatePremium : '/individual-insurance/api/v1/family-health-insurance/calculate-premium',
    getNotificationCount : '/api/v1/syncNotificationCounter',
    getPolicies : '/api/v1/policies/get-user-policies/',
    checkPoliciesPresent : '/api/v1/policies/check-user-policies/',
    getPolicyCard : '/api/v1/policies/get-user-ecard-policies/',
    getPolicyCardDetails: '/api/v1/policies/get-user-ecard-policies/',
    getPamPolicyDetails: '/pam/api/v1/notify/get-policy-by-policynumber?',
    getPolicyNumberFilter: '/api/v1/policies/get-policy-by-id/',
    getClaimsInfo: '/pam/api/v1/notify/get-policy-by-mobile?',
    getMISChartData: '/pam/api/v1/notify/get-claims-mis?',
    getEndorsmentData: '/pam/api/v1/endorsement/deposit-certificate/list?',
    getAppDownloadCount: '/api/getMasterUserCount/',
    getInsureLogos : '/pam/api/v1/notify/get-insurer-logo',
    getTPA:'/pam/api/v1/notify/tpa-name?policyNumber=',
    getPolicyByPolicyID : '/pam/api/v1/notify/get-policy-by-policyid?id=',
    getEclaims:'/pam/api/v1/eclaims/claims-search?',
    getCDledger:'/pam/api/v1/endorsement/deposit-certificate/list?',
    submitPolicyEditOrRenewRequest: '/pam/api/v1/notify/policy-edit-renew-request',
    motorGoDigitDownloadSuccessPdf : '/individual-insurance/api/v1/motor-insurance-go-digit/policy-pdf-url',
    familyHealthfinalPremiumRoyalSundram : '/individual-insurance/api/v1/family-health-insurance/final-premium-proposal-royal-sundaram',
    familyHealthPayRoyalSundaram: '/individual-insurance/api/v1/transaction/initiate-royal-sundaram-payment',
    familyHealthPayCareHealth: '/individual-insurance/api/v1/transaction/initiate-care-health-payment',
    sendPolyclinicRequest: '/pam/api/v1/polyclinic/send-mail',
    saveSurgicalCare: '/api/v1/surgicalCare/save',
    saveCosmeticCare: '/api/v1/cosmeticCare/save',
    //partner agent
    retrieveQuote:'/api/v1/retrieveQuoteByQuoteId/?',
    retrieveQuoteList: '/pam/api/v1/prospect-page/retrieve-quotes?',
    returningUserQuote: '/api/v1/retrieveQuote?quoteId=',
    sendretrieveSMS: '/pam/api/v1/sms/sms-returning-url',
    sendretrieveEmail: '/pam/api/v1/mail/mail-returning-url',
    getRMProspects: '/api/v1/public/getDataTableAssignedProspects',
    getRMClients: '/api/v1/public/getDataTableNewClientData',
    getRMRenewals: '/api/v1/public/getDataTableRenewalClientsData',
    assignRM: '/prospect/assign.json',
    getUserData: '/api/v2/get/user',
    getLatestRetrieveQuote: '/api/v1/retrieveLatestProspect/?mobile=',
    getLatestRetrieveQuoteUsingNotify: '/api/v1/policy/eclaims/retrieveLatestProspect/',
    //polyclinic
    getPolyStatus: '/api/v1/polyclinic/checkStatus',
    getSurgicalCareStatus: '/api/v1/surgicalCare/checkStatus',
    getCosmeticCareStatus: '/api/v1/cosmeticCare/checkStatus',
    //Referral
    getWalletHistory: '/api/v1/getreferall/',
    redeemWalletPoints: '/api/v1/redeemPoints/',
    getClaimsHistory:'/pam/api/v1/eclaims/get-status-history/',
    getClaimsHistoryUsingNotify: '/api/v1/policy/eclaims/get-status-history/',
    // claimHistory: '/pam/api/v1/eclaims/get-status-history/',

    noByInsurer: '/pam/api/v1/eclaims/get-claim-no-by-insurer/',
    noByInsurerUsingNotify: '/api/v1/policy/eclaims/get-claim-no-by-insurer/',
    getdocuments: '/pam/api/v1/eclaims/get-documents/',
    getdocumentsUsingNotify: '/api/v1/policy/eclaims/get-documents/',
    getamount: '/pam/api/v1/eclaims/get-amount/',
    agentStaticsData: '/profession/api/v1/getClientDetails/',
    agentDashboardData:'/profession/api/v1/getLeadDeatails/',
    agentComment:'/profession/api/v1/getLeadComment/',
    updateAgentComment:'/profession/api/v1/updateLeadComment/',

    referredDetailslist: '/api/v1/referredDetails',
    sendEmails: '/api/v1/sendEmail/',

    sendEmailss: '/api/v1/sendEmailReminder/',

    deleteReferral:'/api/v1/deleteRefer/',

    getAgent:'/profession/api/v1/getAgent/',
    saveClickEvent:'/api/v1/app/clickEvent/save',
    pamReferralList:'/pam/api/v1/referral/referral-list-app',
    savePolyclinicInMongo:'/api/v1/polyclinic/save',
    tickets:'https://securein.freshdesk.com/api/v2/tickets?email=',
    getStateListCare:'/pam/api/v1/eclaims/get-state-for-care',
    getCityListCare:'/pam/api/v1/eclaims/get-city-for-care',
    getHospitalListCare:'/pam/api/v1/eclaims/get-hospital-for-care',
    getSingleReferralStatus:'/profession/api/v1/get-referral-status/',
    seniorCitizenCalc:'/calc/seniorCitizenCalc',
    seniorCitizenCareCalc:'/platform-sales/api/secure-now/get-fhi-senior_citizen-premium',
    saveSeniorDataInPlatform:'/platform-sales/api/web/calculate/premium',
    paymentForSeniorCitizen:'/platform-sales/api/transaction/initiatePayment',
    setMobileEmail: '/api/v1/profile/',
    sendWelcomeLoginMail: '/api/v1/firstLogin/mail',
    walletForEcardView:'/api/v1/e-card-wallet/',
    attendanceTabCheckStatus: '/api/v1/attendanceTab-status/',
    verifyAuthToken: '/api/v2/ozp/vn/_xcn/eyb.iv',
    retrieveQuoteListUsingNotify: '/api/v1/policy/retrieve-quotes/',
    downloadClaimForm: '/admin/api/v1/admin-base-policy/downloadRepoFile?id=',
    getAllActiveEcards:'/api/v1/get/all-policy/e-card/',
    deleteActiveEcardsApi:'/api/v1/app/endorsement/deletePolicies',
    deletionInProgressActiveEcardsApi:'/api/v1/app/endorsement/get-pending-deleted/',
    previewProratedPremiumApi:'/api/v1/admin-endorsement-greytHr/upload-endorsement',
    saveEndoresementForApp:'/api/v1/endorsement/deposit-certificate-client/save-employees',
    getAllBatchesForPolicy:'/api/v1/endorsement/deposit-certificate-client/get-all-batches?policyNumber=',
    getAllEmployeeFromBatchApi:'/api/v1/endorsement/deposit-certificate-client/get-employees-details-by-batchId?batchId=',
    getBatchDetailsFromBatchId:'/api/v1/endorsement/deposit-certificate-client/get-batch-status?batchId=',
    updateEmployeeEcard:'/api/v1/app/endorsement/park/update',
    additionInProgressActiveEcardsApi:'/api/v1/get/addition-inprogress/',
    updationInProgressActiveEcardsApi:'/api/v1/get/update-inprogress/',
    saveEmloyeeTempInNotifyApi:'/api/v1/endoresement/park/addition',
    AddtionTempInNotifyApi:'/api/v1/endoresement/addition-inprogress/not-initiated',
    editEmployeeEcardsApi:'/api/v1/endorsement/update/addition-inprogess/',
    getHoldCdBalanceApi:'/pam/api/v1/notify/get-endorsement-amount?clientId=',
    getAndUpdateFreeGpStatus: '/api/v1/update-freeGP-status/',
    batchesUpdateInProgres:'/api/v1/app/endorsement/batch-update-inprogress',
    allUpdationBatches:'/api/v1/app/endorsement/get-all-updated-batches',
    getAllEmployeesFromBatchWithUpdate:'/api/v1/app/endorsement/update-inprogress-batchdetails/',
    getLinkFromExcelUpload:'/profession/api/v1/notify-excel-upload',
    getParentsDataApi:'/api/v1/app/endorsement/get-parent-users',
    getDownloadEcard:'/api/v1/policies/ecarddownloadactivelist',
    superTopUpLeadCreation: '/profession/api/v1/createSuperTopUpLead',
    corporateHealthCheckup:'/api/v1/coprorate-health-checkup/',
    getUserHealthAssessment:'/api/v1/get-user-health-assessment/',
    saveUserHealthAssessment:'/api/v1/save-user-health-assessment',
    getNotifications: '/api/notifications/get-user-notifications/',
    getCountOfNotifications: '/api/notifications/unread-count/',
    markNotificationAsRead: '/api/notifications/mark-as-read/',
   
}